import { object, mixed } from 'yup';

const schema = object().shape({
    product: mixed().required(),
    capacity: mixed().required(),
});

export default schema;
